/**
 * Bot difficulty tiers. The ids are internal and ordinal; the display names are
 * what players vote on — flavored identities rather than bare adjectives, so
 * picking a lower tier reads as a style, not an admission (the Halo
 * Recruit/Marine/ODST/Spartan pattern).
 *
 * Order is part of the wire protocol for the difficulty vote — never reorder.
 */
export type BotTier = 'easy' | 'normal' | 'hard' | 'expert';

export const BOT_TIERS: readonly BotTier[] = ['easy', 'normal', 'hard', 'expert'];

export const BOT_TIER_NAMES: Record<BotTier, string> = {
  easy: 'Rookie',
  normal: 'Regular',
  hard: 'Veteran',
  expert: 'Ace',
};

/** One-line skill hint per tier, shown next to the vote. */
export const BOT_TIER_HINTS: Record<BotTier, string> = {
  easy: 'slow to react, sprays wide',
  normal: 'a fair fight for most',
  hard: 'quick, accurate, hunts you down',
  expert: 'tournament-grade aim and nerve',
};

export const botTierIndex = (tier: BotTier): number => BOT_TIERS.indexOf(tier);

export const botTierFromIndex = (index: number): BotTier =>
  BOT_TIERS[index] ?? 'normal';
